<template>
    <b-tabs
        class="apprentice-pills-tab group-results-tab"
        pills
        vertical
        nav-wrapper-class="col-12 col-lg-3 col-xl-2 d-none d-lg-block"
        content-class="col-12 col-lg-9 col-xl-10 group-results-tab-content">
        <b-tab :title="$t('portfolio.statistics')">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-chart-pie fa-fw"></i>{{ $t('portfolio.statistics') }}</div>
                </div>
            </template>

            <design-2021-group-results-tab-content-component
                :assignments-in="assignments"
                @updateSelectedAssignment="selectAssignment">
            </design-2021-group-results-tab-content-component>
        </b-tab>

        <b-tab :title="$t('portfolio.answers')">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-table fa-fw"></i>{{ $t('portfolio.answers') }}</div>
                </div>
            </template>
            <design-2021-portfolio-answers-spreadsheet :group-in="groupIn"> </design-2021-portfolio-answers-spreadsheet>
        </b-tab>

        <b-tab :title="$t('portfolio.answers.download')">
            <template v-slot:title>
                <div class="tab-title">
                    <div class="title"><i class="fas fa-file-download fa-fw"></i>{{ $t('portfolio.answers.download') }}</div>
                </div>
            </template>
            <design-2021-portfolio-answers-download-files :group-in="groupIn"></design-2021-portfolio-answers-download-files>
        </b-tab>
    </b-tabs>
</template>
<script>
export default {
    name: 'design-2021-group-results-component',
    props: {
        groupIn: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            portfolio: null,
            selectedAssignmentId: null,
        };
    },
    mounted() {
        this.getProjectData();
    },
    computed: {
        selectedAssignment() {
            return this.assignments.find((assignment) => assignment.id === this.selectedAssignmentId);
        },
        assignments() {
            let assignments = [];
            if (this.portfolio) {
                this.portfolio.categories
                    .sort((a, b) => a.order - b.order)
                    .forEach((category) => {
                        category.assignments
                            .sort((a, b) => a.order - b.order)
                            .forEach((assignment) => {
                                assignments.push(assignment);
                            });
                    });
            }
            return assignments;
        },
    },
    methods: {
        getProjectData() {
            this.axios.get(this.routes.getPortfolioResultsForGroup(this.groupIn.id)).then(
                (response) => {
                    this.portfolio = response.data;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        selectAssignment(assignment) {
            this.selectedAssignmentId = assignment.id;
        },
    },
};
</script>

<style scoped lang="scss"></style>
